"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkerSVGDraw = void 0;
const core_api_1 = require("@ikegps/core-api");
const marker_drawable_1 = require("../../model/collection/drawable/marker.drawable");
const mithril_1 = require("../mithril");
const theme_1 = require("../theme");
const label_draw_svg_1 = require("./label.draw.svg");
const util_draw_svg_1 = require("./util.draw.svg");
const util_draw_svg_2 = require("./util.draw.svg");
const MARKER_CIRCLE_RADIUS = 6;
class MarkerSVGDraw {
    static view(marker, options) {
        var _a, _b, _c;
        // If the current element is an insight one, but we don't have the ability to view them, then don't render it.
        if (marker.isInsightMeasurement) {
            if (!options.isInsightMarkersVisible) {
                return null;
            }
            if (marker.isApprovableInsightDrawable() &&
                !((_a = options.insightMarkerTypesVisible) !== null && _a !== void 0 ? _a : []).includes((_c = (_b = marker.insight) === null || _b === void 0 ? void 0 : _b.detection_class) !== null && _c !== void 0 ? _c : '')) {
                return null;
            }
        }
        if (!marker.isVisible) {
            return null;
        }
        const output = [];
        // If there is a label, draw it.
        if (marker.label) {
            output.push(label_draw_svg_1.LabelSVGDraw.view(marker.label, options));
        }
        const startPoint = { x: marker.x - options.draw.state.markerOffsetWidth, y: marker.y };
        const endPoint = { x: marker.x + options.draw.state.markerOffsetWidth, y: marker.y };
        const isMoveable = options.isInteractive && marker.type !== core_api_1.MarkerType.BASE_OFFSET;
        // Draw a line for the marker itself on the center of the pole.
        output.push(util_draw_svg_1.SVGUtil.DrawLineMain(startPoint, endPoint, options.scale));
        output.push(util_draw_svg_1.SVGUtil.DrawLineSecondary(startPoint, endPoint, options.scale, marker.isInsightMeasurement ? theme_1.StyleConfig.STOKE_SECONDARY_INSIGHT : theme_1.StyleConfig.STROKE_SECONDARY, isMoveable ? theme_1.ClassNames.isMoveable : undefined));
        // If the marker is draggable, draw a transparent "move line" (essentially a rectangle)
        // over the marker for user interaction.
        if (options.isInteractive) {
            if (marker_drawable_1.CollectionModelDrawableMarker.isMarker(marker) && marker.pair) {
                if (options.isVerticalSeparationEnabled) {
                    output.push(util_draw_svg_1.SVGUtil.DrawMoveLine(startPoint, endPoint, options.scale));
                }
            }
            else {
                output.push(util_draw_svg_1.SVGUtil.DrawMoveLine(startPoint, endPoint, options.scale));
            }
        }
        output.push(MarkerSVGDraw.DrawHandle(marker, options));
        const isSelected = options.draw.state.selectedId === marker.id;
        const isHighlighted = options.draw.state.hoverId === marker.id;
        const classNames = [
            theme_1.ClassNames.marker.container,
            marker.type === core_api_1.MarkerType.BASE ? theme_1.ClassNames.marker.isBase : null,
            marker.type === core_api_1.MarkerType.BASE_OFFSET ? theme_1.ClassNames.marker.isBaseOffset : null,
            isSelected ? theme_1.ClassNames.isSelected : null,
            isHighlighted ? theme_1.ClassNames.isHighlighted : null,
        ];
        return (0, mithril_1.m)('g', {
            key: marker.id,
            className: classNames.join(' '),
            'c-Draw-node-id': marker.id,
            'c-Draw-tag': 'marker',
        }, output);
    }
    static DrawHandle(marker, options) {
        const isSelected = options.draw.state.selectedId === marker.id;
        const isHighlighted = options.draw.state.hoverId === marker.id;
        const isMoveable = options.isInteractive && marker.type !== core_api_1.MarkerType.BASE_OFFSET;
        const pointClassNames = [
            isSelected ? theme_1.ClassNames.isSelected : null,
            isSelected ? theme_1.ClassNames.point.isSelected : null,
            isHighlighted ? theme_1.ClassNames.point.isHighlighted : null,
            isMoveable ? theme_1.ClassNames.isMoveable : null,
        ];
        // Styles for hover and select state
        if (options.isInteractive && (isSelected || isHighlighted)) {
            var pointFillColor = theme_1.StyleConfig.LABEL.FILL;
            var pointStrokeColor = theme_1.StyleConfig.LABEL.STROKE;
            if (marker.isInsightMeasurement) {
                pointFillColor = theme_1.StyleConfig.LABEL.FILL_INSIGHT;
                if (isHighlighted) {
                    pointStrokeColor = theme_1.StyleConfig.LABEL.FILL_INSIGHT;
                }
                else {
                    pointStrokeColor = theme_1.StyleConfig.STROKE;
                }
            }
            else {
                pointFillColor = theme_1.StyleConfig.LABEL.FILL;
                if (isHighlighted) {
                    pointFillColor = theme_1.StyleConfig.LABEL.FILL_HIGHLIGHTED;
                }
                else if (isSelected) {
                    pointFillColor = theme_1.StyleConfig.LABEL.FILL_SELECTED;
                    pointStrokeColor = theme_1.StyleConfig.STROKE;
                }
            }
            let pointDraggable = marker.type !== core_api_1.MarkerType.BASE_OFFSET;
            // normal user can't drag open space
            if (marker_drawable_1.CollectionModelDrawableMarker.isMarker(marker) && marker.pair && !options.isVerticalSeparationEnabled) {
                pointDraggable = false;
            }
            // If label is on the left, draw the point on the left.
            // Otherwise, draw the point on the right.
            const point = {
                x: marker.label.isOnLeftSide()
                    ? marker.x - options.draw.state.markerOffsetWidth // Left
                    : marker.x + options.draw.state.markerOffsetWidth, // Right
                y: marker.y,
            };
            return util_draw_svg_1.SVGUtil.DrawPoint(point, {
                className: pointClassNames.join(' '),
                radius: options.scale * MARKER_CIRCLE_RADIUS,
                scale: options.scale,
                fill: pointFillColor,
                stroke: pointStrokeColor,
                draggable: pointDraggable,
                label: marker.type !== core_api_1.MarkerType.BASE_OFFSET ? util_draw_svg_2.IkeDrawLabel.POINT : undefined,
            });
        }
    }
}
exports.MarkerSVGDraw = MarkerSVGDraw;
//# sourceMappingURL=marker.draw.svg.js.map